import { toggleElementClassConditionally } from '@/utils/dom-helpers';

export const activeHover = {
  mounted(el, binding) {
    const { childSelector, inactiveClass } = binding.value;
    const childTargets = el.querySelectorAll(childSelector);

    childTargets.forEach((childTarget) => {
      childTarget.addEventListener('mouseover', (e) => {
        const isNotCurrentTarget = (_childTarget) => _childTarget !== e.currentTarget;
        toggleElementClassConditionally(childTargets, isNotCurrentTarget, inactiveClass);
      });

      childTarget.addEventListener('mouseout', () => {
        toggleElementClassConditionally(childTargets, () => false, inactiveClass);
      });
    });
  },
};
